import styled from "styled-components";

/** Alinhado ao InfoSection / FirmsCard da página de área */
export const Section = styled.section`
  margin-top: 0;
  width: 100%;
  padding: 1.15rem 1.25rem 1.35rem;
  border-radius: 14px;
  background: var(--surface-1);
  border: 1px solid var(--border-default);
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem 0.9rem 1.15rem;
    border-radius: 12px;
  }
`;

export const SectionTitle = styled.h2`
  margin: 0 0 0.65rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--accent);
`;

export const Hint = styled.p`
  margin: 0 0 1rem;
  font-size: 0.92rem;
  color: var(--text-secondary);
  line-height: 1.5;
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const Card = styled.article`
  padding: 0.9rem 1rem;
  border-radius: 12px;
  background: var(--surface-2);
  border: 1px solid var(--border-default);
`;

export const CardTitle = styled.h3`
  margin: 0 0 0.4rem;
  font-size: 1rem;
  font-weight: 650;
  color: var(--text-primary);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
`;

export const CardMeta = styled.p`
  margin: 0.15rem 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
  line-height: 1.4;
`;

export const CardActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
  align-items: center;
`;

export const Empty = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: var(--text-secondary);
  padding: 0.85rem 0 0.15rem;
  line-height: 1.45;
`;

export const ConstructionStage = styled.div`
  flex: 1 1 auto;
  width: 100%;
  min-height: calc(100dvh - 13rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.35rem;
  padding: 1.5rem 1.25rem 3rem;
  box-sizing: border-box;
`;

export const ConstructionArt = styled.svg`
  width: min(280px, 72vw);
  height: auto;
  margin-bottom: 0.85rem;
`;

export const ConstructionTitle = styled.h2`
  margin: 0;
  font-size: clamp(1.35rem, 2.4vw, 1.75rem);
  font-weight: 700;
  color: var(--text-heading);
  line-height: 1.25;
`;

export const ConstructionText = styled.p`
  margin: 0.45rem 0 0;
  max-width: 36ch;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--text-secondary);
`;

export const TiffLink = styled.a`
  align-self: center;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--accent);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const EditorLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const EditorShell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-top: 0.5rem;
  padding: 1rem 1.1rem 1.15rem;
  border-radius: 14px;
  background: var(--surface-1);
  border: 1px solid var(--border-default);
  box-sizing: border-box;
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
  padding: 0.15rem 0 0.35rem;

  button {
    background: var(--accent-soft);
    border: 1px solid var(--border-default);
    border-radius: 999px;
    color: var(--text-heading);
    cursor: pointer;
    font-family: inherit;
    padding: 0.6rem 1.15rem;
    font-size: 0.88rem;
    font-weight: 600;
    min-height: 42px;
    line-height: 1.2;

    &:hover:not(:disabled) {
      border-color: var(--accent);
    }

    &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
  }
`;

export const ToolbarHint = styled.p`
  margin: 0;
  width: 100%;
  font-size: 0.88rem;
  color: var(--text-secondary);
  line-height: 1.45;
`;

export const CanvasWrap = styled.div`
  position: relative;
  width: 100%;
  overflow: auto;
  border-radius: 12px;
  border: 1px solid var(--border-default);
  background: var(--surface-2);
  max-height: 70vh;
  margin-top: 0.35rem;
  padding: 0.85rem;
  box-sizing: border-box;
`;

export const StackedCanvas = styled.div`
  position: relative;
  display: inline-block;
  line-height: 0;
  max-width: 100%;

  canvas {
    display: block;
    max-width: 100%;
    border-radius: 8px;
  }

  canvas.overlay {
    position: absolute;
    inset: 0;
    cursor: crosshair;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 1fr));
  gap: 0.95rem 1.15rem;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--text-secondary);

  input,
  textarea,
  select {
    padding: 0.55rem 0.7rem;
    border-radius: 8px;
    border: 1px solid var(--border-default);
    background: var(--surface-2);
    color: var(--text-primary);
    font-size: 0.95rem;
    font-weight: 500;
    text-transform: none;
    letter-spacing: normal;
    font-family: inherit;
  }

  textarea {
    min-height: 72px;
    resize: vertical;
  }
`;

export const StatusPill = styled.span`
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  background: ${({ $confirmed }) =>
    $confirmed ? "var(--accent-soft)" : "var(--surface-1)"};
  color: ${({ $confirmed }) =>
    $confirmed ? "var(--accent)" : "var(--text-secondary)"};
  border: 1px solid
    ${({ $confirmed }) =>
      $confirmed ? "var(--accent)" : "var(--border-default)"};
`;

export const FormPageTop = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  margin-top: 0.75rem;
  margin-bottom: 1.25rem;
  padding-top: 0.5rem;
`;

export const AreaInfoCard = styled.section`
  width: 100%;
  margin: 0 0 1.25rem;
  padding: 1rem 1.15rem;
  border-radius: 14px;
  background: var(--surface-1);
  border: 1px solid var(--border-default);
  box-sizing: border-box;
`;

export const AreaInfoTitle = styled.h2`
  margin: 0 0 0.85rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--accent);
`;

export const AreaInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.85rem 1.5rem;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const AreaInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;

  &[data-full="true"] {
    grid-column: 1 / -1;
  }
`;

export const AreaInfoLabel = styled.span`
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary);
`;

export const AreaInfoValue = styled.p`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.4;
  word-break: break-word;
`;

export const FormActions = styled.div`
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
  margin-top: 0.35rem;
`;
